module.exports = __webpack_public_path__ + "img/lt-icone-phone-violet.6270338d.svg";